import React from 'react';
import { OccationOfferCard } from '../../../helpers/list-page/interfaces/list-card.interface';
import { useCountdownClock } from '../../../hooks/use-countdown-clock';
import {
  CountdownState,
  getCountdownState,
  getZoneFromDate,
} from '../../../helpers/countdown';
import { parseDateTime } from '../../../helpers/dates';
import { IMeetingPlacePageOfferItem } from '@/lib/fragments/meetingPlacePageOfferItem';
import { useGetTimezone } from '@/providers/ConfigProvider';

interface CountdownProps {
  countdownState: CountdownState;
}

interface WithOfferCountdownProps {
  card: OccationOfferCard | IMeetingPlacePageOfferItem;
  children: (props: CountdownProps) => React.ReactNode;
}

export const WithCountdown = ({ card, children }: WithOfferCountdownProps) => {
  const timezone = useGetTimezone();
  const zone = getZoneFromDate(card.validTo.toString(), timezone);
  const now = useCountdownClock(zone);

  const validTo = parseDateTime(card.validTo?.toString(), timezone);
  const validFrom = parseDateTime(card.validFrom?.toString(), timezone);

  const countdownState = now
    ? getCountdownState(validTo, validFrom, now)
    : { type: 'none' as const };

  //   const validToday = now ? isValidToday(validFrom, validTo, now) : false;

  return <>{children({ countdownState })}</>;
};
